// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#ev_radio {
  --radio-width: 20px;
  --radio-height: 20px;
}
#ev_radio .labelwidth-50 {
  width: 50px;
}
#ev_radio .labelwidth-65 {
  width: 65px;
}
#ev_radio .labelwidth-100 {
  width: 100px;
}
#ev_radio .labelwidth-150 {
  width: 150px;
}
#ev_radio .labelwidth-200 {
  width: 200px;
}
#ev_radio.horizontal {
  display: flex;
  flex-direction: row;
}
#ev_radio.horizontal > :not(:first-child) {
  margin-left: 16px;
}
#ev_radio.horizontal .radio-label {
  margin-left: 8px;
}
#ev_radio.vertical {
  display: flex;
  flex-direction: column;
}
#ev_radio.vertical > :not(:first-child) {
  margin-top: 16px;
}
#ev_radio .radio-wrapper {
  display: flex;
  flex-direction: row;
  align-items: center;
  height: var(--radio-height);
}
#ev_radio .radio-input {
  display: block;
  width: var(--radio-width);
  height: var(--radio-height);
  position: relative;
}
#ev_radio .radio-inputinput[type=radio] {
  width: 100%;
  height: 100%;
  border: 2px solid var(--dark-color-main);
  border-radius: 50%;
  vertical-align: -2px;
  appearance: none;
  cursor: pointer;
  transition: border-color 0.2s ease-in-out;
}
#ev_radio .radio-inputinput[type=radio]:before {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%) scale(0);
  width: 60%;
  height: 60%;
  border-radius: 50%;
  background: var(--dark-color-main);
  content: "";
  transition: transform 0.3s ease-in-out;
}
#ev_radio .radio-inputinput[type=radio]:checked:before {
  transform: translate(-50%, -50%) scale(1);
}
#ev_radio .radio-input.loading {
  border-radius: 50%;
}
#ev_radio .radio-label {
  display: block;
  margin-top: calc(var(--radio-height) * 0.15);
  line-height: calc(var(--radio-height));
  margin-left: 8px;
}`, "",{"version":3,"sources":["webpack://./src/_core/components/common/UI/Radio.scss"],"names":[],"mappings":"AAAA;EACC,mBAAA;EACA,oBAAA;AACD;AACC;EACC,WAAA;AACF;AACC;EACC,WAAA;AACF;AACC;EACC,YAAA;AACF;AACC;EACC,YAAA;AACF;AACC;EACC,YAAA;AACF;AAEC;EACC,aAAA;EACA,mBAAA;AAAF;AAEE;EACC,iBAAA;AAAH;AAGE;EACC,gBAAA;AADH;AAKC;EACC,aAAA;EACA,sBAAA;AAHF;AAKE;EACC,gBAAA;AAHH;AAOC;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;AALF;AAQC;EACC,cAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;AANF;AAQE;EACC,WAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,oBAAA;EAGA,gBAAA;EACA,eAAA;EACA,yCAAA;AANH;AASE;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,yCAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,kCAAA;EACA,WAAA;EACA,sCAAA;AAPH;AAUE;EACC,yCAAA;AARH;AAWE;EAEC,kBAAA;AAVH;AAcC;EACC,cAAA;EACA,4CAAA;EACA,sCAAA;EACA,gBAAA;AAZF","sourcesContent":["#ev_radio {\r\n\t--radio-width:  20px;\r\n\t--radio-height: 20px;\r\n\r\n\t.labelwidth-50 {\r\n\t\twidth: 50px;\r\n\t}\r\n\t.labelwidth-65 {\r\n\t\twidth: 65px;\r\n\t}\r\n\t.labelwidth-100 {\r\n\t\twidth: 100px;\r\n\t}\r\n\t.labelwidth-150 {\r\n\t\twidth: 150px;\r\n\t}\r\n\t.labelwidth-200 {\r\n\t\twidth: 200px;\r\n\t}\r\n\r\n\t&.horizontal{\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\r\n\t\t> :not(:first-child) {\r\n\t\t\tmargin-left: 16px;\r\n\t\t}\r\n\r\n\t\t.radio-label{\r\n\t\t\tmargin-left: 8px;\r\n\t\t}\r\n\t}\r\n\r\n\t&.vertical{\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: column;\r\n\r\n\t\t> :not(:first-child) {\r\n\t\t\tmargin-top: 16px;\r\n\t\t}\r\n\t}\r\n\r\n\t.radio-wrapper{\r\n\t\tdisplay: flex;\r\n\t\tflex-direction: row;\r\n\t\talign-items: center;\r\n\t\theight: var(--radio-height);\r\n\t}\r\n\r\n\t.radio-input {\r\n\t\tdisplay: block;\r\n\t\twidth:  var(--radio-width);\r\n\t\theight: var(--radio-height);\r\n\t\tposition: relative;\r\n\r\n\t\t&input[type=\"radio\"] {\r\n\t\t\twidth: 100%;\r\n\t\t\theight: 100%;\r\n\t\t\tborder: 2px solid var(--dark-color-main);\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tvertical-align: -2px;\r\n\t\t\t-webkit-appearance: none;\r\n\t\t\t-moz-appearance: none;\r\n\t\t\tappearance: none;\r\n\t\t\tcursor: pointer;\r\n\t\t\ttransition: border-color 0.2s ease-in-out;\r\n\t\t}\r\n\t\t\r\n\t\t&input[type=\"radio\"]:before {\r\n\t\t\tposition: absolute;\r\n\t\t\ttop: 50%;\r\n\t\t\tleft: 50%;\r\n\t\t\ttransform: translate(-50%, -50%) scale(0);\r\n\t\t\twidth: 60%;\r\n\t\t\theight: 60%;\r\n\t\t\tborder-radius: 50%;\r\n\t\t\tbackground: var(--dark-color-main);\r\n\t\t\tcontent: '';\r\n\t\t\ttransition: transform 0.3s ease-in-out;\r\n\t\t}\r\n\t\t\r\n\t\t&input[type=\"radio\"]:checked:before {\r\n\t\t\ttransform: translate(-50%, -50%) scale(1);\r\n\t\t}\r\n\r\n\t\t&.loading\r\n\t\t{\r\n\t\t\tborder-radius: 50%;\r\n\t\t}\r\n\t}\r\n\t\r\n\t.radio-label{\r\n\t\tdisplay: block;\r\n\t\tmargin-top: calc(var(--radio-height) * 0.15);\r\n\t\tline-height: calc(var(--radio-height));\r\n\t\tmargin-left: 8px;\r\n\t}\r\n\r\n\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
